"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.splice.js");

var _vue = _interopRequireDefault(require("vue"));

var dropdowns = [];
!_vue["default"].prototype.$isServer && document.addEventListener('click', function (event) {
  dropdowns.forEach(function (dropdown) {
    var target = event.target;
    if (!dropdown || !dropdown.$el) return;

    if (target === dropdown.$el || dropdown.$el.contains(target)) {
      return;
    }

    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
  });
});
var _default = {
  open: function open(instance) {
    if (instance) {
      dropdowns.push(instance);
    }
  },
  close: function close(instance) {
    var index = dropdowns.indexOf(instance);

    if (index !== -1) {
      dropdowns.splice(instance, 1);
    }
  }
};
exports["default"] = _default;